import {
  Animal,
  Customer,
  Metadata,
} from "components/Signup/store/state/types";
import {
  resparkBreedsString,
  resparkSexString,
  validStartDate,
} from "utils/insurance";
import {
  SpeciesEnum,
  UpsertDraftInput,
} from "../../../../../../__generated__/globalTypes";
import { getResparkProductNameFromSignupProduct } from "./utils";

export const getInputFromState = ({
  draftId,
  customer,
  metadata,
  animals,
}: {
  draftId: string | null;
  customer: Customer;
  metadata: Metadata;
  animals: Animal[];
}): UpsertDraftInput => {
  return {
    _id: draftId,
    clientInput: {
      address: {
        ...customer.address,
        zip: customer.address?.zip ?? "",
      },
      allowMarketing: customer.marketingPermissionAccepted,
      birthdate: customer.birthdate,
      email: customer.email,
      firstName: customer.firstName,
      lastName: customer.lastName,
      phone: customer.phone,
      region: customer.region,
      ssn: customer.ssn,
    },
    policyInputs: animals.flatMap((animal) =>
      animal.insurances.map((insurance) => {
        return {
          _id: insurance.id,
          productName: getResparkProductNameFromSignupProduct({
            species: animal.species,
            product: insurance.product,
          }),
          effectiveDate: validStartDate({
            birthday: animal.birthday!,
            startDate: insurance.startDate,
          }),
          billingInterval: insurance.billingInterval,
          billingDay: insurance.billingDay,
          limit: insurance.limit,
          deductible: insurance.deductible,
          ratingsData: {
            name: animal.name!,
            breed: resparkBreedsString(
              animal.breed?.id,
              animal.mixedBreedFHalf?.id,
              animal.mixedBreedSHalf?.id
            ),
            birthday: animal.birthday!,
            sex: resparkSexString(animal.sex!, animal.sexSituation!),
            copay: insurance.copay,
            ...(animal.species === SpeciesEnum.cat
              ? { access: animal.access }
              : {}),
            lifeLimit: (insurance.lifeLimit ?? 0) * 100,
            lifeUtilityAddOn: insurance.lifeUtilityAddOn,
            breedersAddOn: insurance.breedersAddOn,
          },
          metadata: {
            discount: insurance.discountCode,
            healthHistory: animal.healthHistory.join(","),
            cancelPreviousInsurance: insurance.insurely?.cancelCompetitor,
            customerSignature: insurance.insurely?.customerSignature,
            compare: insurance.insurely?.shouldCompare,
            eurobonusMemberId: customer.eurobonusMemberId,
            lunarMemberId: customer.lunarMemberId,
            previousInsurance:
              insurance.insurely?.currentInsurelyPolicyIndex !== undefined
                ? JSON.stringify(
                    insurance.insurely.policies?.[
                      insurance.insurely.currentInsurelyPolicyIndex
                    ]
                  )
                : undefined,
          },
        };
      })
    ),
  };
};
